<template lang="html">
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    :nudge-top="36"
    transition="scale-transition"
    offset-y
    min-width="290px"
    @click.stop=""
  >
    <template #activator="{ on: { click } }">
      <v-text-field
        ref="input"
        v-model="dateFormatted"
        v-bind="$attrs"
        :label="`${internalLabel} (${dateFormat})` "
        prepend-inner-icon="event"
        :hint="dateRange"
        :rules="evaluatedRules"
        validate-on-blur
        @click:prepend-inner="click"
        @change="validateDate"
        @click.native.stop="click"
        @keydown="keydown"
        @paste="handlePaste"
      />
    </template>
    <v-date-picker
      ref="picker"
      v-model="date"
      :min="min"
      :max="max"
      :picker-date.sync="pickerDate"
      @input="dateInput"
    />
  </v-menu>
</template>

<script>
import { forEach } from 'lodash'
import moment from 'moment'
import element from '@/mixins/element'
export default {
  mixins: [ element ],
  props: {
    returnUnix: Boolean,
    min: {
      type: String,
      default: '1900-01-01'
    },
    max: {
      type: String
      // default: new Date().toISOString().substr(0, 10)
      // default: new Date().toISOString().substr(0, 10)
    },
    returnFormat: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    dateFormat: {
      type: String,
      default: 'DD-MM-YYYY'
    },
    pasteFormats: {
      type: Array,
      default: () => [
        { format: 'DD-MMM-YYYY', regex: /([0-9]{1,2}-([a-z,A-Z]{3})-[0-9]{4})/ },
        { format: 'DD/MMM/YYYY', regex: /([0-9]{1,2}\/([a-z,A-Z]{3})\/[0-9]{4})/ },
        { format: 'DD/MM/YYYY', regex: /([0-9]{1,2}\/([0-9]{1,2})\/[0-9]{4})/ },
        { format: 'DD-MM-YYYY', regex: /([0-9]{1,2}-([0-9]{1,2})-[0-9]{4})/ }
      ]
    },
    value: [ String, Number ]
  },
  data () {
    return {
      date: '0',
      dateFormatted: '',
      pickerDate: moment().format('YYYY-MM'),
      menu: false,
      moment: moment,
      internalChange: false,
      messages: [],
      lazyValue: '',
      // requiredRule: v => (this.dateIsValid(v) && !!v) || `${this.$attrs.label || 'This field'} is required`
      requiredRule: v => (moment(v).isValid() && !!v) || `${this.$attrs.label || 'This field'} is required`
    }
  },
  computed: {
    dateRange () {
      return (this.min || this.max) ? `Valid dates: ${this.min ? moment(this.min).format(this.dateFormat) : 'any'} <-> ${this.max ? moment(this.max).format(this.dateFormat) : 'any'}` : null
    },
    conditionalRules () {
      return this.menu ? [] : this.internalRules
    }
  },
  watch: {
    dateFormatted () {
      this.internalChange = true
      this.$nextTick(() => { this.internalChange = false })
    },
    date (v) {
      if (v) this.syncDate(v, 'date')
    },
    value: {
      handler (v) {
        // TODO: LOOK AT THIS !V might mean lazy is not
        if (!this.internalChange) this.syncDate(v, 'value')
        // if (!this.internalChange && v) this.syncDate(moment(v), 'value')
      },
      immediate: true
    },
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
      // TODO: make it so that I can set date picker to default to year or month.
      // need to be able to set the date min/maxes then a focus year. i.e. selecting someting
      // in a FY set min to 1 july and max to 30 june for that year then set the year to the
      // date to the year of the selected FY and focus level to month.
    }
  },
  methods: {
    validateDate () {
      let date = moment(moment(this.dateFormatted, this.dateFormat).format())
      if (this.dateIsValid(date) && this.dateInBounds(date)) {
        this.syncDate(date.format())
      } else {
        this.dateFormatted = ''
        this.date = ''
        this.$emit('input', '')
        this.$emit('change', '')
      }
    },
    dateInBounds (date) {
      let valid = true
      if (this.min && !moment(this.min).isSameOrBefore(date)) valid = false
      if (this.max && !moment(this.max).isSameOrAfter(date)) valid = false
      return valid
    },
    dateIsValid (date) {
      var dateHypen = moment(date, this.dateFormat.replace(/\//gi, '/'), true).isValid()
      var dateSlash = moment(date, this.dateFormat.replace(/-/gi, '/'), true).isValid()
      return dateHypen || dateSlash
    },
    dateInput () {
      this.menu = false
      this.$refs.input.focus()
      this.$nextTick(() => {
        this.$refs.input.blur()
      })
    },
    syncDate (formattedDate) { // date sent as date string
      let date = moment(formattedDate)
      if (!formattedDate || !date._isValid) {
        this.dateFormatted = ''
        this.lazyValue = ''
        this.$emit('input', '')
        this.$emit('change', '')
        return
      }
      // var dateFormatted = date.format(this.dateFormat)
      var dateEmit = this.returnUnix ? date.valueOf() : date.format(this.returnFormat).toString()
      // if (this.returnUnix) {
      //   dateEmit = date.valueOf()
      // } else if (this.returnFormat) {
      //   dateEmit = date.format(this.returnFormat)
      // } else {
      //   dateEmit = date.format()
      // }

      this.dateFormatted = date.format(this.dateFormat).toString()
      this.lazyValue = dateEmit
      this.$emit('input', dateEmit)
      this.$emit('change', dateEmit)
    },
    handlePaste () {
      setTimeout(() => {
        try {
          let pastedDate = this.dateFormatted
          let matchFound = false

          forEach(this.pasteFormats, format => {
            if (format.regex.test(pastedDate)) {
              let d = moment(pastedDate, format.format)
              if (d._isValid) {
                this.syncDate(d.format())
                matchFound = true
              }
            }
          })

          if (!matchFound) this.dateFormatted = ''
        } catch (error) {
          console.error(error)
          this.dateFormatted = ''
        }
      })
    },
    focus () {
      this.$refs.input.focus()
    },
    keydown (e) {
      this.$emit('keydown', e)
      this.menu = false
      if (e.code === 'Semicolon' && e.ctrlKey) {
        this.dateFormatted = moment().format(this.dateFormat)
        this.pickerDate = moment().format('YYYY-MM')
        this.validateDate()
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>
